import React, { useEffect } from 'react'
function TermsConditions() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }, [])
    return (
        <div className="bg-texture bg-white min-vh-100">
            <div class="container mx-auto d-flex flex-column gap-3 py-3 fon">
                <div><h1 class="fw-medium display-6">Terms Of Use</h1></div>
                <div>
                    <div><h4 class="fw-normal">1. Introduction</h4></div>
                    <div class="text_grey">
                        THIS DOCUMENT IS AN ELECTRONIC RECORD IN TERMS OF THE INFORMATION
                        TECHNOLOGY ACT, 2000 AND RULES MADE THEREUNDER. THIS ELECTRONIC RECORD
                        IS GENERATED BY A COMPUTER SYSTEM AND DOES NOT REQUIRE ANY PHYSICAL OR
                        DIGITAL SIGNATURES.
                        <br /><br />
                        THIS DOCUMENT IS PUBLISHED IN ACCORDANCE WITH THE PROVISIONS OF RULE
                        3(1) OF THE INFORMATION TECHNOLOGY (INTERMEDIARIES GUIDELINES) RULES,
                        2011 THAT REQUIRES PUBLISHING THE RULES AND REGULATIONS, PRIVACY
                        POLICY AND TERMS OF USE FOR ACCESS OR USAGE OF THIS WEBSITE.
                        <br /><br />
                        The website www.TrotterIt.com and the associated mobile application
                        (Android) (hereinafter referred to as the “Website”) is owned by
                        Techedge Systems & Engineers Pvt Ltd, a company incorporated under the
                        Companies Act, 2013 with its registered office at Mayur Vihar, Delhi
                        (“Trotter It“). Trotter It offers the following services: Providing a
                        website, and apps for the Android, providing a platform for the
                        creation of travel blogs, archiving personal travel stories, photos
                        and video (hereinafter “Memories”) and for use as a social network for
                        travelers. Trotter It also offers the following products: Personalized
                        travel videos , expanding the range reserved, which are configured and
                        manufactured by Trotter It on the basis of data provided by the user
                        (hereinafter “products”) (products and services are jointly referred
                        to as “services”).
                        <br /><br />
                        Trotter It reserves the right, at its sole discretion, to change,
                        modify, add or remove portions of these Terms of Use (“the Terms”), at
                        any time without any prior written notice to you. It is your sole
                        responsibility to review these Terms periodically for updates or
                        changes. Your continued use of the Website following the posting of
                        changes shall be deemed to mean that you accept and agree to the
                        revisions. As long as you comply with these Terms, Trotter It grants
                        you a personal, non-exclusive, non-transferable, limited privilege to
                        access and use the Website.
                        <br /><br />
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">2. Membership Eligibility</h4></div>
                    <div class="text_grey">
                        Use of the Website is available only to persons who can enter into
                        legally binding contracts under the Indian Contract Act, 1872. Persons
                        who are “incompetent to contract” within the meaning of the Indian
                        Contract Act, 1872 including minors, un-discharged insolvents and
                        persons of unsound mind are not eligible to use the Website. Any
                        person under the age of 18 shall not register on the Website and shall
                        not transact on or use the Website. If a minor wishes to use or
                        transact on the Website, such use or transaction may be made by the
                        minor’s legal guardian or parents on the Website. Trotter It reserves
                        the right to terminate any person’s membership and/or refuse to
                        provide such person with access to the Website if it is brought to
                        Trotter It notice or if it is discovered that such person is not
                        eligible to use the Website.
                        <br /><br />
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">3. Acceptance of Terms</h4></div>
                    <div class="text_grey">
                        Please carefully read these Terms. By accessing or using the Website,
                        you are agreeing to these Terms and concluding a legally binding
                        contract with Trotter It. You may not use the Website if you do not
                        accept the Terms or unable to be bound by the Terms.
                        <br /><br />
                        In order to use the Website, you must first agree to the Terms. You
                        can accept the Terms by:
                        <br />
                        <br />
                        <ul>
                            <li>
                                Logging into Trotter It by via Facebook, Google Plus or your
                                personal e-mail; or
                            </li>
                            <li>
                                Actually using the Website. In this case, you understand and agree
                                that Trotter It will treat your use of the Website as acceptance
                                of the Terms from that point onwards.
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">4. Opening an Account</h4></div>
                    <div class="text_grey">
                        In order to use the Website, you will have to create an account on the
                        Website (“the Account”), which can be done either by signing up
                        through Facebook, Google Plus or by your personal e-mail. As part of
                        the application, you will be required to provide an e-mail address and
                        a password which is to be used for logging into the Account in the
                        future. You shall not transfer or share your Account password with
                        anyone, or create more than one Account.
                        <br /><br />
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">5. Usernames/Passwords</h4></div>
                    <div class="text_grey">
                        The confidentiality of your username and password is to be maintained
                        by you and in case of any misappropriation or unauthorized access of
                        the Account you agree to communicate the same promptly to Trotter It.
                        Any information regarding this will be sent to the e-mail address
                        which was used at the time of sign up.
                        <br /><br />
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">6. Agreement to receive Mails</h4></div>
                    <div class="text_grey">
                        <ul>
                            <li>
                                You understand and agree that the Service may include
                                advertisements and that these advertisements are necessary for
                                Trotter It to provide the Service.
                            </li>
                            <li>
                                You also understand and agree that the Service may include certain
                                communications from Trotter It, such as service announcements and
                                administrative messages and that these communications are
                                considered part of Trotter It membership and you will be able to
                                opt out of receiving them.
                            </li>
                            <li>
                                Unless explicitly stated otherwise, any new features that augments
                                or enhances the current Service, including the release of new
                                Trotter It properties, shall be subject to this Terms of Use.
                            </li>
                            <li>
                                Live Journeys/Past Journeys created by any user on the Website
                                will be considered public information and will be shown to other
                                users using the Website. Trotter Itcan use these for any purpose
                                that it deems fit for the benefit of Trotter It community.
                            </li>
                            <li>
                                If you don’t want to register/unregister/unsubscribe from the
                                Service, please send an email to info@TrotterIt.com. Trotter It
                                will honour all user requests to users from the service. However,
                                Trotter It cannot guarantee immediate actions on the same since
                                this may have technical implications on the Service and impact
                                other users using the Service. Trotter Itshall make reasonable
                                efforts to fulfil such user requests within a reasonable time
                                period.
                            </li>
                            <li>
                                You are responsible for obtaining access to the Service and that
                                access may involve third party fees (such as Internet service
                                provider or airtime charges). You are responsible for those fees,
                                including those fees associated with the display or delivery of
                                advertisements. In addition, you must provide and are responsible
                                for all equipment necessary to access the Service.
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">8. Links to Third Party Websites</h4></div>
                    <div class="text_grey">
                        The Website may contain links and interactive functionality
                        interacting with the websites of third parties. Trotter It is not
                        responsible for and has no liability for the functionality, actions,
                        inactions, privacy settings, privacy policies, terms, or content of
                        any such website. Before enabling any sharing functions to communicate
                        with any such website or otherwise visiting any such website, Trotter
                        It strongly recommends that you review and understand the terms and
                        conditions, privacy policies, settings, and information-sharing
                        functions of each such third-party website.
                        <br /><br />
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">9. Use of the Website</h4></div>
                    <div class="text_grey">
                        <p>
                            You agree, undertake and covenant that, during the use of the
                            Website,
                        </p>
                        <ul>
                            <li>
                                you shall not host, display, upload, modify, publish, transmit,
                                update or share any information that belongs to another person or
                                entity and to which you do not have any right.
                            </li>
                            <li>
                                create any account for anyone other than yourself without such
                                person’s permission;
                            </li>
                            <li>create more than one personal account;</li>
                            <li>
                                use a user name that is the name of another person with the intent
                                to impersonate that person;
                            </li>
                            <li>
                                use a user name or Trotter It account that is subject to any
                                rights of a person other than you without appropriate
                                authorization;
                            </li>
                            <li>
                                use a user name that is a name that is otherwise offensive, vulgar
                                or obscene or otherwise unlawful
                            </li>
                            <li>
                                use your personal ‘profile’ and ‘travel feed’ (i.e. your ‘home
                                screen’) and other data for your own commercial gain,
                            </li>
                            <li>
                                host, display, upload, modify, publish, transmit, update or share
                                any information that is grossly harmful, harassing, blasphemous,
                                defamatory, obscene, pornographic, paedophilic, libellous,
                                invasive of another person’s privacy, hateful or racially or
                                ethnically objectionable, or encouraging money laundering or
                                gambling, or otherwise unlawful in any manner whatsoever.
                            </li>
                            <li>
                                host, display, upload, modify, publish, transmit, update or share
                                any information that is misleading in any way.
                            </li>
                            <li>
                                host, display, upload, modify, publish, transmit, update or share
                                any information that involves the transmission of “junk mail”,
                                “chain letters”, or unsolicited mass mailing or “spamming”.
                            </li>
                            <li>
                                host, display, upload, modify, publish, transmit, update or share
                                any information that infringes upon or violates any third party’s
                                rights including, but not limited to, intellectual property
                                rights, rights of privacy (including without limitation
                                unauthorized disclosure of a person’s name, e-mail address,
                                physical address or phone number) or rights of publicity.
                            </li>
                            <li>
                                host, display, upload, modify, publish, transmit, update or share
                                any information that tries to gain unauthorized access or exceeds
                                the scope of authorized access to the Website or to profiles,
                                blogs, communities, account information, bulletins, or other areas
                                of the Website or solicits passwords or personally identifying
                                information for commercial or unlawful purposes from other users
                                of the Website.
                            </li>
                            <li>
                                host, display, upload, modify, publish, transmit, update or share
                                any information that engages in commercial activities without
                                Trotter It’s prior written consent such as engages in contests,
                                sweepstakes, barter, advertising etc.
                            </li>
                            <li>interfere with another user’s use of the Website.</li>
                            <li>
                                refer to any website or URL that, in Trotter It’s sole discretion,
                                contains material that is inappropriate for the Website or any
                                other website, contains content that would be prohibited or
                                violates the letter or spirit of these Terms.
                            </li>
                            <li>
                                deceive or mislead the addressee/ users about the origin of such
                                messages or communicate any information which is grossly offensive
                                or menacing in nature.
                            </li>
                            <li>
                                host, display, upload, modify, publish, transmit, update or share
                                any information that contains software viruses or any other
                                computer codes, files or programs designed to interrupt, destroy
                                or limit the functionality of any computer resource; or contains
                                any trojan horses, worms or other computer programming routines
                                that may damage, detrimentally interfere with, diminish value of,
                                covertly intercept or steal any system, data or personal
                                information.
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">10. Your Account and Content</h4></div>
                    <div class="text_grey">
                        <ul>
                            <li>
                                Trotter Itdoes not claim ownership of content you submit or make
                                available for inclusion on the Service. You own all of the content
                                and information you post and share etc., on Trotter It (“User
                                Content”), and you can control how it is shared through your
                                privacy settings.
                            </li>
                            <li>
                                If you have a ‘private’ profile, any content and information,
                                including but not limited to your Journeys, photos, videos and
                                reviews, you and share etc. on your profile shall be shared with
                                persons who follow your profile.
                            </li>
                        </ul>
                        <p>
                            However, with respect to content you submit or make available for
                            inclusion on publicly accessible areas of the Services, you grant
                            Trotter It the following world-wide, royalty free and non-exclusive
                            license(s), as applicable:
                        </p>
                        <ul>
                            <li>
                                With respect to content you submit or make available for inclusion
                                publically accessible features on Trotter It, the license to use,
                                distribute, reproduce, modify, adapt, publicly perform and
                                publicly display such content on the Service for the purposes of
                                providing and promoting Trotter It. This license exists only for
                                as long as you elect to continue to include such content on the
                                Service and will terminate at the time you remove or Trotter It
                                removes such content from the Service.
                            </li>
                            <li>
                                With respect to photos, graphics, audio or video you submit or
                                make available for inclusion on publicly accessible area of the
                                Service the license to use, distribute, reproduce, modify, adapt,
                                publicly perform and publicly display such content on the Service
                                for the purpose for which such content was submitted or made
                                available. This license exists only for as long as you elect to
                                continue to include such content on the Service and will terminate
                                at the time you remove or Trotter It removes such content from the
                                Service;
                            </li>
                            <li>
                                With respect to content other than photos, graphics, audio or
                                video you submit or make available for inclusion on publicly
                                accessible areas of the Service, the perpetual, irrevocable and
                                fully sub-licensable license to use, distribute, reproduce,
                                modify, adapt, publish, translate, publicly perform and publicly
                                display such content (in whole or in part) and to incorporate such
                                content into other works in any format or medium now known or
                                later developed.
                            </li>
                        </ul>
                        <p>
                            “Publicly accessible” areas of the Service are those areas of the
                            service that will be available to the general public. By way of
                            example, publicly accessible areas of the Service would include user
                            profile pages, Journeys, Past Journies, Travel Life, Local Life, My
                            Life, etc.
                        </p>
                        <ul>
                            <li>
                                Trotter It does not take responsibility or any liability
                                whatsoever nature with regard to any particulars of restaurants,
                                hotels, places, events, service providers, tour operators
                                etc.,thatTrotter It may recommend in its Editors’ Itineraries. It
                                is clearly understood that the Editor only recommends and does not
                                require any written consent from such third parties and therefore
                                no liability is taken up by Trotter It for such recommendation or
                                acting thereupon by any user.
                            </li>
                            <li>
                                You hereby grant Trotter It a perpetual, non-revocable, worldwide,
                                royalty-free and sub-licensable right and license to use, copy,
                                distribute, display, publish, transmit, make available, reproduce,
                                modify, adapt the User Content and create derivate works of the
                                User Content in any manner as deemed appropriate by Trotter It in
                                any form including but not limited to print, broadcast, online and
                                across any and all websites owned by Trotter It , any and all
                                platforms owned by Trotter It on any social media channel
                                including but not limited to Instagram, Facebook and Twitter. You
                                represent and warrant that you own or otherwise control all of the
                                rights to the User Content that you post or that you otherwise
                                provide on or through the Website; and that, as at the date that
                                the User Content is posted or submitted on the Website: (i) the
                                User Content is accurate; (ii) use of the User Content you supply
                                does not breach these Terms; and (iii) that such User Content is
                                lawful.
                            </li>
                            <li>
                                You further represent and warrant that while posting any User
                                Content on the Website you shall not use any offensive, libellous,
                                derogatory, hateful or racially or ethnically objectionable
                                language. Further, you shall not post any content on the Website
                                that is obscene, pornographic, constitutes an “indecent
                                representation of women” as provided in The Indecent
                                Representation of Women (Prohibition) Act, 1986.
                            </li>
                            <li>
                                You acknowledge and agree that Trotter It may preserve User
                                Content and may also disclose User Content if required to do so by
                                law or in the good faith belief that such preservation or
                                disclosure is reasonably necessary to:
                            </li>
                            <ol>
                                Comply with legal process.
                            </ol>
                            <ol>
                                Enforce the Terms of Use.
                            </ol>
                            <ol>
                                Respond to claims that any content violates the rights of third
                                parties; or
                            </ol>
                            <ol>
                                Protect the rights, property, or personal safety of Trotter It ,
                                its users and the public.
                            </ol>
                            <li>
                                You understand that the technical processing and transmission of
                                the Services, including your User Content, may involve – (a)
                                Transmissions over various networks; and (b) Changes to conform
                                and adapt to technical requirements of connecting networks or
                                devices.
                            </li>
                            <li>
                                Trotter It does not claim ownership of the images, pictures or
                                photos posted by users on the Website. The images are user
                                contributed images. Trotter Itis not liable for any damages,
                                claims that may arise out of any copyright violation that happens
                                because of user contributed images. Trotter It will comply with
                                Digital Millennium Copyright Act (DMCA). DMCA assures swift
                                removal of images for copyright owners and provides a safe harbor
                                from liability for complying web hosts once put on notice. We
                                respect all copyright owners and will always comply with well
                                documented notices.
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div>
                        <h4 class="fw-normal">
                            11. Use of Blogs, including messaging between Users and / or Travel
                            Agents etc.
                        </h4>
                    </div>
                    <div class="text_grey">
                        <ul>
                            <li>
                                The Website may contain discussion blogs or other forums in which
                                you or third parties may post reviews, comments of travel
                                experiences or other content, messages, materials or other items
                                on the Website. If Trotter It provides such interactive areas, you
                                are solely responsible for your use of such interactive areas and
                                use them at your own risk.
                            </li>
                            <li>
                                By using any interactive areas, you expressly agree not to post,
                                upload to, transmit, comment, distribute, store, create or
                                otherwise publish through the Website any of the following:
                            </li>
                            <li>
                                any message, data, information, text, videos, music, sound,
                                photos, graphics, code or other material (“content“) that is
                                unlawful, libellous, defamatory, obscene, pornographic, indecent,
                                lewd, suggestive, harassing, threatening, invasive of privacy or
                                publicity rights, abusive, inflammatory, fraudulent or otherwise
                                objectionable;
                            </li>
                            <li>
                                content that would constitute, encourage or provide instructions
                                for a criminal offense, violate the rights of any party, or that
                                would otherwise create liability or violate any local, state,
                                national or international law, including, without limitation, the
                                regulations of the Securities and Exchange Board of India or any
                                rules of a securities exchange where the shares of the concerned
                                entity have been listed such as the National Stock Exchange and
                                the Bombay Stock Exchange;
                            </li>
                            <li>
                                content that may infringe any patent, trademark, trade secret,
                                copyright or other intellectual or proprietary right of any party;
                            </li>
                            <li>
                                content that impersonates any person or entity or otherwise
                                misrepresents your affiliation with a person or entity;
                            </li>
                            <li>
                                unsolicited promotions, political campaigning, advertising or
                                solicitations;
                            </li>
                            <li>
                                private information of any third party, including, without
                                limitation, addresses, phone numbers, email addresses, personal
                                identification numbers and credit card numbers;
                            </li>
                            <li>
                                viruses, corrupted data or other harmful, disruptive or
                                destructive files;
                            </li>
                            <li>
                                content that is unrelated to the topic of the interactive area(s)
                                in which such content is posted; or
                            </li>
                            <li>
                                content that, in the sole judgment of Trotter It , is
                                objectionable or which restricts or inhibits any other person from
                                using or enjoying the interactive areas or the Website, or which
                                may expose Trotter It or its affiliates or its users to any harm
                                or liability of any type.
                            </li>
                            <li>
                                Trotter It takes no responsibility and assumes no liability for
                                any content posted, shared, liked, stored or uploaded by you or
                                any third party, or for any loss or damage thereto, nor is Trotter
                                It liable for any mistakes, defamation, slander, libel, omissions,
                                falsehoods, obscenity, pornography or profanity you may encounter.
                                As a provider of interactive services, Trotter It is not liable
                                for any statements, representations or content provided by its
                                users in any public forum, personal home page or other interactive
                                area. Although Trotter It has no obligation to screen, edit or
                                monitor any of the content posted to or distributed through any
                                interactive area, Trotter It reserves the right, and has absolute
                                discretion, to remove, screen or edit without notice any content
                                posted or stored on the Website at any time and for any reason,
                                and you are solely responsible for creating backup copies of and
                                replacing any content you post or store on the Website at your
                                sole cost and expense.
                            </li>
                            <li>
                                Any use of the interactive areas or other portions of the Website
                                in violation of the foregoing violates these Terms and may result
                                in, among other things, termination or suspension of your rights
                                to use the interactive areas and/or the Website. Trotter Itmay
                                provide, or third parties may provide, links to other World Wide
                                Websites or Mobile Application or resources. Since Trotter It has
                                no control over such Website or Mobile Application or resources,
                                you acknowledge and agree that Trotter It is not responsible for
                                the availability of such external Website or Mobile Application or
                                resources, and does not endorse and is not responsible or liable
                                for any content, advertising, products, or other materials on or
                                available from such Website or Mobile Application or resources.
                                You further acknowledge and agree that Trotter It shall not be
                                responsible or liable, directly or indirectly, for any damage or
                                loss caused or alleged to be caused by or in connection with use
                                of or reliance on any such content, goods or services available on
                                or through any such Website or resource.
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">12. Limitation of Liability</h4></div>
                    <div class="text_grey">
                        You hereby acknowledge that Trotter It shall not be held liable to you
                        for any special, consequential, incidental, and exemplary or punitive
                        damages, or loss of profit or revenues. We are also not liable under
                        any circumstances for damages arising out or related in any way to
                        your inability to access, or your difficulty in accessing the Website,
                        any bugs, viruses, trojan horses, or the like, which may be
                        transmitted to or through the Website by any third party, any loss of
                        your data or content from the services, your failure to keep your
                        password or Account details secure and confidential. LLB shall not be
                        liable under any circumstances for damages arising out of or in any
                        way related to products, services and/or information offered or
                        provided by third-party vendors accessed through the Website.
                        <br /><br />
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">13. Disclaimer of Warranties</h4></div>
                    <div class="text_grey">
                        THE WEBSITE AND ALL INFORMATION, CONTENT, MATERIALS AND SERVICES
                        INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE WEBSITE
                        (COLLECTIVELY, THE “CONTENTS”) ARE PROVIDED BYTROTTER IT ON AN “AS
                        IS,” “AS AVAILABLE” BASIS, WITHOUT REPRESENTATIONS OR WARRANTIES OF
                        ANY KIND. TROTTER IT MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY
                        KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE WEBSITE, THE
                        ACCURACY OR COMPLETENESS OF THE CONTENTS AND THE ACCURACY OF THE
                        INFORMATION. TROTTER IT SHALL HAVE NO RESPONSIBILITY FOR ANY DAMAGE TO
                        YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF
                        ANY CONTENT, MATERIALS, DOCUMENT OR INFORMATION. YOU EXPRESSLY AGREE
                        THAT THE USE OF THE WEBSITE IS AT YOUR SOLE RISK. TROTTER IT WILL NOT
                        BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE WE
                        SITE OR THE CONTENTS INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT,
                        CONSEQUENTIAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE
                        SPECIFIED IN WRITING. TO THE FULL EXTENT PERMITTED BY LAW, TROTTER IT
                        DISCLAIMS ANY AND ALL REPRESENTATIONS AND WARRANTIES WITH RESPECT TO
                        THE WEBSITE AND ITS CONTENTS, WHETHER EXPRESS OR IMPLIED, INCLUDING,
                        WITHOUT LIMITATION, WARRANTIES OF TITLE, MERCHANTABILITY, AND FITNESS
                        FOR A PARTICULAR PURPOSE OR USE.
                        <br /><br />
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">14. Indemnification</h4></div>
                    <div class="text_grey">
                        This is a free for use Website. Users’ liability may be financial and
                        monetary for which Trotter It takes no responsibility and may be to
                        any extent. If Trotter It is impleaded in any court action, minimum
                        damages @Rs2500000 shall be recoverable from such user. Users do
                        hereby indemnify and keep indemnified Trotter It from all losses,
                        damages, claims etc. that may arise. Trotter It is not a booking agent
                        or a travel agency (apart from being a meta-search engine), and does
                        not charge service fees to users of the Website. Your correspondence
                        or business dealings with, or participation in promotions of,
                        advertisers found on or through the Service, including payment and
                        delivery of related goods or services, and any other terms,
                        conditions, warranties or representations associated with such
                        dealings, are solely between you and such advertiser / travel agent
                        /local agent/ tour operator/ third party recommendations like
                        restaurants, hotels, places, events, service providers, tour operators
                        etc., on the Service. You agree that Trotter It shall not be
                        responsible or liable for any loss or damage of any sort incurred as
                        the result of any such dealings or as the result of the presence of
                        such advertiser / travel agent /local agent/ tour operator/ third
                        party recommendations like restaurants, hotels, places, events,
                        service providers, tour operators etc., on the Service. Trotter It
                        does not take responsibility or any liability whatsoever nature with
                        regard to any particulars of restaurants, hotels, places, events,
                        service providers, tour operators etc. that Trotter It may recommend
                        in its Editors’ Itineraries or Must Dos. It is clearly understood that
                        the Editor only recommends and does not require any written consent
                        from such third parties and therefore no liability is taken up by
                        Trotter It for such recommendation or acting thereupon by any user or
                        travel agent.
                        <br /><br />
                    </div>
                </div>

                <div>
                    <div>
                        <h4 class="fw-normal">
                            15. Content and Intellectual Property Rights
                        </h4>
                    </div>
                    <div class="text_grey">
                        <ul>
                            <li>
                                Trotter It solely and exclusively owns copyrights, trademarks,
                                service marks, logos, trade names, and other intellectual and
                                proprietary rights associated with our Service and Contents and is
                                protected under Indian law.
                            </li>
                            <li>
                                Trotter It .com, Trotter It Mobile Application and/or, Trotter It
                                logo, and other company logos and product and service names are
                                trademarks of Techedge Systems & Engineers Pvt Ltd. Without
                                Trotter It ‘s prior permission, you agree not to display or use
                                them in any manner.
                            </li>
                            <li>
                                You hereby acknowledge that the Service constitute original works
                                and have been developed, compiled, prepared, revised, selected,
                                and arranged by us and others through the application of methods
                                and standards of judgment developed and applied through the
                                expenditure of substantial time, effort, and money and constitutes
                                valuable intellectual property of us and such others. You thereby
                                agree to protect the proprietary rights of Trotter It during and
                                after the term of these Terms. You may not selectively download
                                portions of the Website without retaining the copyright notices
                                You may download material from the Website only for your own
                                personal use and for no commercial purposes whatsoever.
                            </li>
                            <li>
                                Any infringement shall lead to appropriate legal proceedings
                                against you at appropriate forum for seeking all available
                                remedies under applicable laws of the country.
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div>
                        <h4 class="fw-normal">16. Termination of Access to your Services</h4>
                    </div>
                    <div class="text_grey">
                        <p>
                            The Account can be terminated at any time by you by ceasing to use
                            the Website.
                        </p>
                        <ul>
                            <li>You agree that Trotter It , in its sole discretion, may terminate your password, account (or any part thereof) or use of the Service, and remove and discard any Content within the Service, for any reason, including, without limitation, for lack of use or if Trotter It believes that you have violated or acted inconsistently with the letter or spirit of the terms of usage. Trotter It may also in its sole discretion and at any time discontinue providing the Service, or any part thereof, with or without notice. You agree that any termination of your access to the Service under any provision of this Terms of Use may be effected without prior notice, and acknowledge and agree that Trotter It may immediately deactivate or delete your account and all related information and files in your account and/or bar any further access to such files or the Service. Further, you agree that Trotter It shall not be liable to you or any third party for any termination of your access to the Service.
                            </li>
                            <li>If we are certain that a user has created multiple accounts in the same name or uses similar names having one single identity, or has uploaded objectionable material on this profile, page or that of others or in any other manner, then Trotter It shall have all rights to block the users account from access, without notice to such user. If you create risk or possible legal exposure for us, we can stop providing all or part of the access to Trotter It by you. We may or may not notify you about the same. You may also delete your account or disable your page at any time. In all such cases, this Statement shall terminate, but the provisions governing your future conduct including responsibilities and liabilities shall still apply.
                            </li>
                            <li>You agree that regardless of any statute or law to the contrary or the applicable dispute resolution process, any claim or cause of action you may have arising out of or related to use of the Service or otherwise under these must be filed within one (1) year after such claim or cause of action arose or you hereby agree to be forever barred from bringing such claim.
                            </li>
                            <li>If anyone brings a claim against us related to your actions, content or information on Trotter It , you will indemnify and hold us harmless from and against all damages, losses, and expenses of any kind (including reasonable legal fees and costs) related to such claim. Although we provide rules for user conduct, we do not control or direct users’ actions on Trotter It and are not responsible for the content or information users transmit or share on Trotter It . We are not responsible for any IP infringed, offensive, inappropriate, obscene, unlawful or otherwise objectionable content or information you may encounter on Trotter It. We are not responsible for the conduct, whether online or offline, or any user of Trotter It. Nothing in these terms of service is intended to exclude or limit any condition, warranty, right or liability which may not be lawfully excluded or limited. Some jurisdictions do not allow the exclusion of certain warranties or conditions or the limitation or exclusion of liability for loss or damage caused by negligence, breach of contract or breach of implied terms, or incidental or consequential damages. Accordingly, only those limitations which are lawful in your jurisdiction (if any) will apply to you and our liability is limited to the maximum extent permitted by law. We try to keep Trotter It up, bug-free, and safe, but you use it at your own risk. We are providing Trotter It as is without any express or implied warranties including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee that Trotter It will always be safe, secure or error-free or that Trotter It will always function without disruptions, delays or imperfections. Trotter Itis not responsible for the actions, content, information, or data of third parties and you release us, our directors, officers, employees, and agents from any claims and damages, known and unknown, arising out of or in any way connected with any claim you have against any such third parties.
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div><h4 class="fw-normal">17. Privacy Policy
                    </h4></div>
                    <div class="text_grey">
                        Please review our <a class="text-primary" href="https://web.trotterit.com/privacy-policy">Privacy Policy</a>, which also governs your visit to the Website, to understand our practices. The personal information / data provided to us by you during the course of usage of the Website will be treated as strictly confidential and in accordance with the Privacy Policy and applicable laws and regulations. If you object to your information being transferred or used, please do not use the Website.
                        <br /><br /></div>
                </div>

                <div>
                    <div><h4 class="fw-normal">18. Governing Law
                    </h4></div>
                    <div class="text_grey">
                        These Terms shall be governed by and interpreted and construed in accordance with the laws of India. The place of jurisdiction shall exclusively be in Delhi, India. In the event of any dispute arising out of these Terms the same shall be settled by a binding arbitration conducted by a sole arbitrator, appointed jointly by both parties and governed by the Arbitration and Conciliation Act, 1996. The venue of arbitration shall be Delhi, India.
                        <br /><br /></div>
                </div>

                <div>
                    <div><h4 class="fw-normal">19. How to Contact Us
                    </h4></div>
                    <div class="text_grey">
                        If you have questions or concerns about this Policy, please contact us at info@TrotterIt.com
                        <br /><br /></div>
                </div>

            </div>
        </div>
    )
}

export default TermsConditions